import { TUpsertUserTypeRolesPayload } from 'modules/settings/models';
import API from 'services/api';

export const upsertUserTypeRole = ({ roleId, payload }: TUpsertUserTypeRolesPayload) => {
  if (!!roleId) {
    return API.put(`/api/roles/${roleId}`, payload);
  } else {
    return API.post('/api/roles', payload);
  }
};
